
import { computed, defineComponent, PropType, reactive, toRefs } from 'vue'
import { directive as clickOutside } from 'click-outside-vue3'

type DropdownItem = string | { label: string; value: string }

export default defineComponent({
	props: {
		modelValue: {
			type: String,
			required: true
		},
		placeholder: {
			type: String,
			required: true
		},
		items: {
			type: Object as PropType<DropdownItem[]>,
			required: true
		}
	},
	directives: {
		clickOutside
	},
	emits: ['update:modelValue'],
	setup(props, { emit }) {
		const state = reactive({
			active: false
		})

		const toggle = () => {
			state.active = !state.active
		}

		const close = () => {
			state.active = false
		}

		const options = computed(() =>
			props.items
				.filter(item => item != null)
				.map(item =>
					typeof item === 'string' ? { label: item, value: item } : item
				)
		)

		const activeValue = computed(() => {
			const selected = options.value.find(
				item => item.value === props.modelValue
			)

			return selected ? selected.label : props.placeholder
		})

		const select = (value: string) => {
			emit('update:modelValue', value)
		}

		const filteredItems = computed(() => {
			return options.value.filter(item => item.value !== props.modelValue)
		})

		return {
			...toRefs(state),
			toggle,
			close,
			activeValue,
			select,
			filteredItems
		}
	}
})
